import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main',
  template: `
    <div class="__main-layout">
      <div class="__navbar-container">
        <app-nav-bar></app-nav-bar>
      </div>
      <div class="__sidebar-container">
        <app-aside-bar></app-aside-bar>
      </div>
      <div class="__router-container">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
  styles: [
    `.__main-layout {
      display: grid;
      grid-template-columns: 250px 1fr;
      grid-template-rows: 72px 1fr;
      height: 100%;
      max-width: 100%;
    }`,
    `@media (max-width:1024px) {
      .__main-layout {
        grid-template-columns: 1fr;
      }
    }`,
    `.__main-layout .__navbar-container{
      grid-column: 1 / 3;
    }`,
    `.__main-layout .__sidebar-container{
      grid-column: 0;
      grid-row: 2 / 3;
      height: 100%;
      max-width: 100%;
    }`,
    `.__main-layout .__router-container{
      background:white;
      max-width: 100%;
      max-height: 100%;
      overflow: auto;
    }`
  ]
})
export class MainComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
